import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import CustomerImportDetailScreen from '../../../../src/screens/CustomerImportDetailScreen';
export default function OwnerCustomerImportDetail() {
  const { id } = useLocalSearchParams<{ id: string }>();
  return <CustomerImportDetailScreen importId={id ?? ''} />;
}
